import type { FlightLogSectionContext } from '../useFlightLogForm'
import { ClockRow, HmmRow, NumRow } from '../../ui/prntr-fields'
import { PrntrGroup } from '../../ui/prntr-input'

export function RouteTimesSection({ context }: { context: FlightLogSectionContext }) {
  const { control, readOnly, fieldError } = context
  return (
    <>
      <PrntrGroup>
        <ClockRow
          control={control}
          name="routeTimes.offBlock"
          label="Off Block"
          readOnly={readOnly}
          error={fieldError('routeTimes.offBlock')}
        />
        <ClockRow
          control={control}
          name="routeTimes.takeOff"
          label="Take Off"
          readOnly={readOnly}
          error={fieldError('routeTimes.takeOff')}
        />
        <ClockRow
          control={control}
          name="routeTimes.landing"
          label="Landing"
          readOnly={readOnly}
          error={fieldError('routeTimes.landing')}
        />
        <ClockRow
          control={control}
          name="routeTimes.onBlock"
          label="On Block"
          readOnly={readOnly}
          error={fieldError('routeTimes.onBlock')}
        />
        <HmmRow
          control={control}
          name="routeTimes.flightTime"
          label="Flight Time"
          readOnly={readOnly}
          error={fieldError('routeTimes.flightTime')}
        />
        <HmmRow
          control={control}
          name="routeTimes.blockTime"
          label="Block Time"
          readOnly={readOnly}
          error={fieldError('routeTimes.blockTime')}
        />
        <NumRow
          control={control}
          name="routeTimes.distanceNm"
          label="Distance"
          suffix="NM"
          readOnly={readOnly}
          error={fieldError('routeTimes.distanceNm')}
        />
      </PrntrGroup>
    </>
  )
}
